import React, { useEffect } from 'react'
import { newOrder as newOrderAction } from '@/checkout-instore-legacy/utils/SidebarUtils'

import { TopbarMenuArea } from '../Instore/components/Header/Topbar'
import { BackButton } from '../../core/components'
import { useHistory } from '../../core/router'

export const OrderPlacedScreen = () => {
  const history = useHistory()

  const shoudRedirectToHome = !!history.location.state?.redirectToHome

  const handleRedirect = () => {
    if (shoudRedirectToHome) {
      newOrderAction()

      return history.push('/')
    }

    return history.goBack()
  }

  useEffect(() => {
    if (shoudRedirectToHome) {
      const unlisten = history.listen((_, action) => {
        if (action === 'POP') {
          handleRedirect()
        }
      })

      return () => {
        // The browser back button event is called after screen unmounting.
        // This line is for delaying unmounting and calling the history event unlistener
        setTimeout(() => unlisten(), 1)
      }
    }

    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shoudRedirectToHome])

  return (
    <TopbarMenuArea>
      <BackButton
        onClick={(e) => {
          e.preventDefault()
          handleRedirect()
        }}
      />
    </TopbarMenuArea>
  )
}
